module.exports = __webpack_public_path__ + "static/media/logo.b4d4a920.svg";